import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    GoogleInfo: null,
    FacebookInfo: null
  },
  mutations: {
    putGoogleInfo(state, obj) {
      state.GoogleInfo = {
        name: obj.getName(),
        givenName: obj.getGivenName(),
        familyName: obj.getFamilyName(),
        imageUrl: obj.getImageUrl(),
        email: obj.getEmail()
      };
    },
    removeGoogleInfo(state) {
      state.GoogleInfo = null;
    },
    putFacebookInfo(state, obj) {
      console.log(obj);
      state.FacebookInfo = {

      };
    },
    removeFacebookInfo(state) {
      state.FacebookInfo = null;
    }
  },
  actions: {},
  modules: {}
});
